import { XML_RenderGroupStart } from "./XML_RenderGroupStart";
import { Globals } from "../CoreApp/Globals";
import { enumElementLayer, enumRenderStep, enumUIModes } from "../constants";
import { QPoint } from "../CoreApp/QPoint";

export function ShrinkScaleToMeasuredContent(
  minPageSize,
  measuredContentX,
  measuredContentY,
  theScale,
  theShift
) {
  const shrinkFactor = Math.min(
    1,
    minPageSize.fX / measuredContentX,
    minPageSize.fY / measuredContentY
  );
  if (shrinkFactor >= 1) return theScale;

  const budgetOutputX = minPageSize.fX * theScale;
  const budgetOutputY = minPageSize.fY * theScale;
  const fitScale = theScale * shrinkFactor;
  theShift.fX += (budgetOutputX - measuredContentX * fitScale) / 2;
  theShift.fY += (budgetOutputY - measuredContentY * fitScale) / 2;
  return fitScale;
}

export function doRenderXML(pageIndex, renderLayer) {
  var g = Globals._bookRenderInfo;
  var pp = g.fPubPanel;
  var theDoc = pp.fWSMgr.GetDoc();
  var divSwitch = null;
  if (Globals._pubSettings.fPubScope == "MultiChart") {
    var docmgr = pp.fWSMgr.GetDocMgr();
    if (g.fCurDocIdx == null) {
      g.fCurDocIdx = 0;
      g.fMultiDocCompletedPages = 0;
      var docName = docmgr.GetIndexDoc(g.fCurDocIdx).GetDivisionName();
      pp.fWSMgr.SwitchToDivision(docName, true);
      divSwitch = docName;
    }
    var curDoc = docmgr.GetIndexDoc(g.fCurDocIdx);
    var scm = curDoc.GetSubChartMgr();
    scm.fBranchRoot = null;
    var curDocPages = scm.GetActiveBranchPages(true);
    if (pageIndex - g.fMultiDocCompletedPages >= curDocPages) {
      g.fMultiDocCompletedPages += curDocPages;
      g.fCurDocIdx++;
      curDoc.fCanvasRef.SetShownState(true);
      var docName = docmgr.GetIndexDoc(g.fCurDocIdx).GetDivisionName();
      pp.fWSMgr.SwitchToDivision(docName, true);
      divSwitch = docName;
    }
    theDoc = pp.fWSMgr.GetDoc();
    scm = theDoc.GetSubChartMgr();
    //g.fOutputDocRef = theDoc;
    pp.fCanvasPanel = theDoc.fCanvasRef;
    pp.fCanvasPanel.SetShownState(false);
    var sc = scm.GetSubChartByPageNum(pageIndex + 1 - g.fMultiDocCompletedPages);
  } else {
    var scm = theDoc.GetSubChartMgr();
    if (pageIndex == -1) var sc = scm.GetIndexPageSubChart();
    else if (typeof pageIndex == "string") {
      for (var anSC in scm.GetIndexPageSubChart().fChildren) {
        var theSC = scm.GetIndexPageSubChart().fChildren[anSC];
        if (theSC.GetSubChartID() == pageIndex) {
          var sc = theSC;
          break;
        }
      }
    } else var sc = scm.GetSubChartByPageNum(pageIndex + 1);
    if (pageIndex === 0 && theDoc.GetDivisionName()) divSwitch = theDoc.GetDivisionName();
  }

  // Create a checkpoint so we can rollback if pictures aren't loaded
  var cp = pp.fCanvasPanel;

  var outDocRef = g.fOutputDocRef;

  outDocRef.CheckPoint();

  // Save current page min size
  var pm = cp.GetPageMgr();
  var oldMinX = pm.GetMinPageWidth();
  var oldMinY = pm.GetMinPageHeight();
  var theScale = null;
  var theShift = null;
  var minPageSize = null;
  var xmlStep = null;
  var inCanvas = null;
  const doingMaster = renderLayer == enumElementLayer.master;

  if (doingMaster) {
    minPageSize = Globals._publishScaler.GetMinPageSize(pageIndex);
    theScale = Globals._publishScaler.GetMasterScaleFactor();
    xmlStep = enumRenderStep.openpage;
  } else {
    theScale = Globals._publishScaler.GetContentScaleFactor(pageIndex);
    theShift = Globals._publishScaler.GetContentShiftCorrection(pageIndex);

    var o_page_size = Globals._publishScaler.GetOutputPageSize();
    var o_marginSize = Globals._publishScaler.GetOutputMargins();
    minPageSize = new QPoint();

    minPageSize.fX = o_page_size.fX - (o_marginSize.fLeft + o_marginSize.fRight);
    minPageSize.fY = o_page_size.fY - (o_marginSize.fTop + o_marginSize.fBottom);

    minPageSize.fX = minPageSize.fX / theScale;
    minPageSize.fY = minPageSize.fY / theScale;

    var minPageSize2 = Globals._publishScaler.GetContentPageSize(pageIndex);

    xmlStep = enumRenderStep.closepage;
    inCanvas = g.fAltCanvas;
    pm.SetPDFModeIndex(pageIndex);
  }

  pm.SetMinPageSize(minPageSize.fX, minPageSize.fY);
  Globals._altLayerToRender = renderLayer;
  if (g.fWorkingPage != pageIndex || renderLayer != g.fWorkingLayer) {
    cp.SwitchToSubChartByObj(sc, false);

    cp.fBackgroundPanel.SetHasVertScrollBar(false);
    g.fWorkingPage = pageIndex;
    g.fWorkingLayer = renderLayer;
  }

  if (!doingMaster) {
    const plm = cp.GetPageLayoutMgr();
    theScale = ShrinkScaleToMeasuredContent(
      minPageSize,
      plm.GetPageWidth(),
      plm.GetPageHeight(),
      theScale,
      theShift
    );
  }

  theDoc.ClearPictureFault();

  var scPath = scm.GetActiveSubChartPath(theDoc.GetShowSubChartNumBM());

  if (theDoc.fDocMgr.GetCompoundDoc()) {
    scPath = theDoc.GetDivisionName().replace("\n", "\\") + "\\" + scPath;
  }

  var out_PageSize = Globals._publishScaler.GetOutputPageSize();
  var pageW = out_PageSize.fX;
  var pageH = out_PageSize.fY;

  if (theShift !== null) {
    pp.fShiftX = theShift.fX;
    pp.fShiftY = theShift.fY;
  }

  var cElement = inCanvas ? inCanvas.GetCanvasElement() : null;
  if (
    Globals._pubSettings.fShowActivity != "Off" &&
    Globals._uiConfig.GetUIMode() === enumUIModes.planning &&
    doingMaster
  ) {
    var planMgr = pp.fWSMgr.GetPlanMgr();
    cp.AddActivityContent(
      planMgr,
      Globals._pubSettings.fShowActivity,
      Globals._publishScaler.fBasePage
    );
  }

  if (!doingMaster && cElement) XML_RenderGroupStart(cElement);

  var altCanvas = pp.RenderXML(
    inCanvas,
    false,
    true,
    pageW,
    pageH,
    outDocRef,
    pageIndex + 1,
    scPath,
    xmlStep,
    theScale,
    divSwitch
  );
  if (doingMaster) g.fAltCanvas = altCanvas;
  //	else if (cElement)
  //		XML_RenderGroupEnd(cElement);

  var pageFault = 0;

  var picFault = theDoc.GetPictureFault();
  pageFault += picFault;

  var pageNeedsLoad = sc && sc.fPageLoaded === false;
  if (pageNeedsLoad) pageFault += 1;

  if (pageFault > 0) {
    outDocRef.Rollback();
    if (renderLayer == enumElementLayer.master) g.fPageRetryQ.unshift(pageIndex);
  }

  // Restore State
  pm.SetMinPageSize(oldMinX, oldMinY);
  Globals._altLayerToRender = null;
  pm.SetPDFModeIndex(-1);
  pp.fShiftX = 0;
  pp.fShiftY = 0;

  return pageFault;
}
